import React, { useEffect, useMemo, useRef, useState } from 'react'
import classnames from 'classnames'
import FirstTooltip from 'meinian-package/src/component/firstTooltip'
import styles from './index.module.less'
import './switch.less'

function SwitchTabs({ option, onChange, value }) {
  const onTabChange = (_value, item) => {
    onChange?.(_value, item)
  }
  return <div className="mn-switch-tabs">
    {option.map(item => <div
      className={classnames({ active: value === item.value })}
      key={item.value}
      onClick={() => onTabChange(item.value, item)}
    >{item.label}</div>)}
  </div>
}

export default SwitchTabs

export const SwitchTabBorder = ({
  allowClear = true,
  allowClearOption = { label: '全部', value: null },
  options,
  onChange,
  value = null
}) => {
  const [sizes, setSizes] = useState([])
  const onTabChange = (_value, item) => {
    onChange?.(_value, item)
  }

  const _options = useMemo(() => {
    if (allowClear) {
      return [allowClearOption].concat(options)
    }
    return options
  }, [allowClearOption, options])

  const contentRef = useRef(null)

  useEffect(() => {
    const childNodes = contentRef.current?.childNodes
    const childSizes = []
    for (let i = 0; i < childNodes.length; i++) {
      childSizes.push(childNodes[i].offsetWidth)
    }
    setSizes([...childSizes])
  }, [contentRef.current, options])

  const _style = useMemo(() => {
    const curIndex = _options.findIndex(i => i.value === value)
    let i = curIndex
    let left = 0

    if (curIndex !== -1 && curIndex) {
      do {
        i--
        left += sizes[i]
      }
      while (i !== 0)
    } else {
      left = 0
    }
    return {
      curIndex,
      left,
      width: sizes[curIndex]
    }
  }, [value, sizes])

  return <div className={styles.mnSwitchTabBorder}>
    <div className="mnSwitchTabBorderItemWrap" ref={contentRef}>
      {_options.map(item => <div
        className={classnames('mnSwitchTabBorderItem', { active: value === item.value })}
        key={item.value}
        onClick={() => onTabChange(item.value, item)}
      >{item.label}</div>)}
    </div>
    <div
      className={classnames('mnSwitchTabBorderItemActive', { first: !_style.curIndex, last: _style.curIndex === _options.length - 1 })}
      style={{
        ..._style,
        width: _style.curIndex === _options.length - 1 ? _style.width : _style.width + 1,
        left: !_style.curIndex ? _style.left : _style.left
      }}
    />
  </div>
}

export const SwitchPageTab = ({ options, value, onChange, renderRight = null, className = null, style = null }) => {
  return <div className={classnames(styles.mnSwitchPageTab, className)} style={style}>
    <SwitchPageTabContent options={options} value={value} onChange={onChange} />
    <div>
      {renderRight?.()}
    </div>
  </div>
}

export const SwitchPageTabContent = ({ options, value, onChange, className = null, onTipClose }) => {
  const getContent = (item) => <div
    className={classnames('page-tab-item', { active: item.value === value })}
    onClick={() => [
      onChange?.(item.value, item)
    ]}
  >
    {item.label}
  </div>

  return <div className={classnames(styles.mnSwitchPageTabLeft, className)}>
    {
  options.map(item => <span className="page-tab-item-wrap">
    {
      item.tipText ? <FirstTooltip
        text={item.tipText}
        placement="right"
        keyValue={item.tipKeyValue}
        visible={item.tipVisible}
        getPopupContainer={(trigger) => trigger.parentElement}
        onClose={onTipClose}
      >
        {getContent(item)}
      </FirstTooltip> : getContent(item)
    }
    <span className={classnames('page-tab-item-num', { active: item.value === value })}>{item.num}</span>
  </span>)
}
  </div>
}
